/**
 * Throttle a function so that it fires once every { threshold }
 * @param {Function} fn
 * @param {Integer} threshold
 * @param {FunctionContext} scope
 */

window.essThrottle = (fn, threshold, scope) => {
	if (!threshold) {
		threshold = 250;
	}

	var last, deferTimer;

	return function () {
		var context = scope || this;
		var now = +new Date();
		var args = arguments;

		if (last && now < last + threshold) {
			// hold on to it
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function () {
				last = now;
				fn.apply(context, args);
			}, threshold);
		} else {
			last = now;
			fn.apply(context, args);
		}
	};
};
